const TwitterIcon = () => `<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 19 18" fill="none">
<path d="M11.524 7.77562L17.481 1H16.0696L10.8948 6.88195L6.76466 1H2L8.2469 9.89534L2 17H3.41143L8.87279 10.787L13.2353 17H18L11.524 7.77562ZM9.5902 9.97343L8.95629 9.0871L3.92043 2.04117H6.08867L10.154 7.72957L10.7852 8.6159L16.0689 16.0096H13.9006L9.5902 9.97343Z" fill="black" stroke="black"/>
</svg>`;
export default TwitterIcon;
